// extracted by mini-css-extract-plugin
export var clientBoxWrapper = "client-box-module--client-box-wrapper--2RMZE";
export var clientLogo = "client-box-module--client-logo--12pYZ";
export var clientText = "client-box-module--client-text--1eWIg";
export var lastItem = "client-box-module--last-item--KH1LI";